import React from "react";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { Button } from "../../Shared/Button";

export const SupportView = () => {
  return (
    <div className="space-y-8">
      <div className="flex justify-center">
        <Button
          as="a"
          href="mailto:support@feedbackflow.dev"
          size="lg"
          leftIcon={<EnvelopeIcon className="h-5 w-5" />}
          className="shadow-large hover:shadow-glow"
        >
          Send Email
        </Button>
      </div>
    </div>
  );
};
